import { cpBaseUrl, GET, POST, PUT, RESPONSE_TYPES } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';

export const settlementsListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/settlements${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const settlementDetailApi = (id) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/settlements/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const markSettledApi = (id, body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/settlements/${id}/mark_paid`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const accountStatementDocumentApi = (id) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/settlements/${id}/account_statement`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadPayoutSheetApi = (body) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/settlements/payout_import`;
    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cpSettlementSheetApi = (params) => {
  const url = `${cpBaseUrl}/settlements/settlements_sheet${params}`;
  return new Promise((resolve, reject) => {
    NetworkManager.performRequest(url, null, GET, null, RESPONSE_TYPES?.blob)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cpFinanceSheetApi = () => {
  const url = `${cpBaseUrl}/settlements/finance_sheet`;
  return new Promise((resolve, reject) => {
    NetworkManager.performRequest(url, null, GET, null, RESPONSE_TYPES?.blob)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
